import { TinkLinkUrlParameter } from '@tink/config/src/TinkLinkUrlParameter';
import { ProductType } from '@tink/core/src/types';
import { ErrorReason, ErrorStatus } from '@tink/core/src/tinkLinkErrorCodes';
import { getValidRefreshableItems } from '../utilities/validators';
import {
  isEnumType,
  validateExternalReference,
  ValidateProductParams,
} from '../utilities/urlParameters';
import { AccountDialogType, ReportType } from './models/report';

export const DEFAULT_ACCOUNT_DIALOG_TYPE = AccountDialogType.NONE;

export const ERR_PARAM_REPORT_TYPES_MISSING = {
  errorStatus: ErrorStatus.BAD_REQUEST,
  errorReason: ErrorReason.INVALID_PARAMETER_REPORT_TYPES,
};

export const ERR_PARAM_REPORT_TYPES_INVALID = {
  errorStatus: ErrorStatus.BAD_REQUEST,
  errorReason: ErrorReason.INVALID_PARAMETER,
};

export const ERR_PARAM_ACCOUNT_DIALOG_TYPE_INVALID = {
  errorStatus: ErrorStatus.BAD_REQUEST,
  errorReason: ErrorReason.INVALID_PARAMETER_ACCOUNT_DIALOG_TYPE,
};

export const validateParams: ValidateProductParams = (
  { async, externalReference },
  getRawParam
) => {
  const errors = [];
  const rawReportTypes = (getRawParam(TinkLinkUrlParameter.REPORT_TYPES) || '')
    .split(',')
    .filter((v) => v !== '');
  const reportTypes = rawReportTypes.filter(isEnumType(ReportType));

  if (!reportTypes.length) {
    errors.push(ERR_PARAM_REPORT_TYPES_MISSING);
  } else if (reportTypes.length !== rawReportTypes.length) {
    errors.push(ERR_PARAM_REPORT_TYPES_INVALID);
  }

  const rawAccountDialogType =
    getRawParam(TinkLinkUrlParameter.ACCOUNT_DIALOG_TYPE) || DEFAULT_ACCOUNT_DIALOG_TYPE;
  const accountDialogTypes = [rawAccountDialogType].filter(isEnumType(AccountDialogType));

  if (accountDialogTypes.length !== 1) {
    errors.push(ERR_PARAM_ACCOUNT_DIALOG_TYPE_INVALID);
  }

  if (async && rawAccountDialogType !== DEFAULT_ACCOUNT_DIALOG_TYPE) {
    errors.push(ERR_PARAM_ACCOUNT_DIALOG_TYPE_INVALID);
  }

  const externalReferenceError = validateExternalReference(externalReference || '');

  if (externalReferenceError) {
    errors.push(externalReferenceError);
  }

  return {
    parameters: {
      refreshableItems: getValidRefreshableItems(
        getRawParam(TinkLinkUrlParameter.REFRESHABLE_ITEMS)
      ),
      async,
      productType: ProductType.REPORTS,
      accountDialogType: accountDialogTypes[0],
      reportTypes,
    },
    errors,
  };
};
